import type { KioskClassRef, KioskLoginSuccess } from "../types/chipTypes";

/**
 * Compact header for the kiosk's teaching view.
 *
 * The Abmelden button used to live here but was removed: the floating
 * KioskCloseButton (top-right) now handles BOTH "log out current teacher"
 * AND "hide window to tray" in a single click. Keeping a separate
 * Abmelden button created ambiguity ("which one closes the kiosk?")
 * and burned screen real-estate on the small touch panels.
 */
export function CompactHeader({
  name,
  session,
  classes,
  activeClass,
  onPickClass,
  onBack,
}: {
  name: string;
  session: KioskLoginSuccess;
  classes?: KioskClassRef[];
  activeClass?: KioskClassRef;
  onPickClass?: (c: KioskClassRef) => void;
  onBack?: () => void;
}) {
  return (
    <header className="flex items-center justify-between gap-4">
      <div className="flex items-baseline gap-3 min-w-0">
        {onBack && (
          <button
            onClick={onBack}
            className="px-2 py-1 rounded text-xs bg-slate-800 hover:bg-slate-700 text-slate-300 font-mono"
          >
            ← Zurück
          </button>
        )}
        <h1 className="text-lg font-light text-slate-50 truncate">{name}</h1>
        <span className="text-xs text-slate-500 font-mono whitespace-nowrap">
          {session.open_entries_count > 0
            ? `${session.open_entries_count} offen`
            : "alles geführt"}
        </span>
      </div>
      <div className="flex items-center gap-2 flex-wrap justify-end">
        {classes && classes.length > 1 && activeClass && onPickClass
          ? classes.map((c) => {
              const active = c.id === activeClass.id;
              return (
                <button
                  key={c.id}
                  onClick={() => onPickClass(c)}
                  className={`px-2.5 py-1 rounded text-xs font-mono transition ${
                    active
                      ? "bg-amber-400 text-slate-900"
                      : "bg-slate-800 hover:bg-slate-700 text-slate-300"
                  }`}
                >
                  {c.name}
                  {c.is_klassenleiter ? " ★" : ""}
                </button>
              );
            })
          : null}
      </div>
    </header>
  );
}
